module.exports = __webpack_public_path__ + "noSyncLogo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noSyncLogo.png
// module id = 1913
// module chunks = 0